<template>
  <div id="content">
    <div class="page-title">常见问题
      <div style="height: 8px"></div>
    </div>
    <div divalign="center" style="font-size: 16px">
      <div class="page-title1">APP远程开锁，如何不使用密码直接开锁
        <div style="height: 8px"></div>
      </div>
      <p class="page-title2">1.进入叮咚APP，点击需要设置的设备，进入设备页面后，点击右上角设置</p>
      <img src="./appopen/ycks1.png" class="bg"/>
      <img src="./appopen/ycks2.png" class="bg"/>
      <p class="page-title2">2.设置页面，点击【安全设置】，将安全密码验证取消勾选之后，即可不使用密码开锁</p>
      <img src="./appopen/ycks3.png" class="bg"/>
      <img src="./appopen/ycks4.png" class="bg"/>
      <img src="./appopen/ycks5.png" class="bg"/>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'no_bind'
  }
</script>

<style scoped>
  .page-title {
    font-size: 18px;
    margin: 20px auto;
    text-align: center;
    display: block;
    line-height: 1;
    left: 118px;
    border-width: 0 0 1px 0;
    font-family:blod  黑体 ;
    font-weight:900;
    border-style: solid;
    border-color: #F5F5F5;
  }

  .page-title1 {
    font-family:blod  黑体 ;
    font-weight:100;

    font-size: 18px;
    margin: 20px auto;
    line-height: 1;
    left: 14px;
    border-width: 0 0 1px 0;

    border-style: solid;
    border-color: #F5F5F5;
  }

  .page-title2 {
    left: 14px;
    height: 26px;
    font-family: 简体;
    font-size: 16px;
    color: #666666;
  }

  .bg {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/commonproblem/appopen/appopen.vue